<template>
  <v-banner single-line>
    <v-icon slot="icon" color="#2f598b" size="36">mdi-information</v-icon>
    {{ mensagem }}
    <template v-slot:actions="{ dismiss }">
      <v-btn icon text color="#2f598b" @click="dismiss">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
export default {
  name: "Aviso",
  props: {
    mensagem: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped></style>
